export const trackingStepShape = {
  stato: "",
  timestamp: "",
  note: "",
};

export const createTrackingStepModel = (overrides = {}) => ({
  ...trackingStepShape,
  ...overrides,
});

